import tw from "twin.macro"

export const Section = tw.section`bg-teal-mint border-t-4 border-teal px-5 md:px-7.5 py-10 md:px-10 text-navy my-10 md:my-16`
